/**
 * @public
 */
export interface BreakpointProps<T> {
  /** Whether the breakpoint is matched. */
  matches: boolean;
  /** The props that should be applied if the breakpoint is matched. */
  props: T;
}

/**
 * `useBreakpointProps` is a hook that returns an object with all matching props
 * that are passed in. In case of multiple props matching and having the same
 * property, the last matching prop takes precedence.
 * @public
 */
export function useBreakpointProps<T>(matchesProps: BreakpointProps<T>[]) {
  let result = {} as T;

  for (const matchesProp of matchesProps) {
    if (matchesProp.matches) {
      result = { ...result, ...matchesProp.props };
    }
  }
  return result;
}
